import { Layout, BarChart3, Star, Megaphone, Type, Image, MessageSquare, MapPin, GripHorizontal } from 'lucide-react';

export const SECTION_TEMPLATES = {
  hero: {
    label: 'Hero Banner',
    description: 'Full-width hero with image',
    icon: Layout,
    defaultProps: {
      heading: 'Your Headline Here',
      subheading: 'Add a compelling subheading for your visitors',
      backgroundImage: 'https://images.unsplash.com/photo-1734903251828-b8d4c0423e56?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwzfHxzZW1pJTIwdHJ1Y2slMjBoaWdod2F5fGVufDB8fHx8MTc3MjM0MjM5M3ww&ixlib=rb-4.1.0&q=85',
      ctaText: 'Get Started',
      ctaLink: '/inventory',
      ctaSecondaryText: '',
      ctaSecondaryLink: '',
      compact: false,
    },
  },
  stats: {
    label: 'Stats Bar',
    description: 'Number statistics in a row',
    icon: BarChart3,
    defaultProps: {
      items: [
        { num: '100+', label: 'Stat Label' },
        { num: '50+', label: 'Stat Label' },
        { num: '99%', label: 'Stat Label' },
        { num: '24/7', label: 'Stat Label' },
      ],
    },
  },
  features: {
    label: 'Features',
    description: 'Icon cards with descriptions',
    icon: Star,
    defaultProps: {
      heading: 'Our Features',
      items: [
        { icon: 'Shield', title: 'Feature One', description: 'Description of this feature.' },
        { icon: 'DollarSign', title: 'Feature Two', description: 'Description of this feature.' },
        { icon: 'Star', title: 'Feature Three', description: 'Description of this feature.' },
      ],
    },
  },
  cta: {
    label: 'Call to Action',
    description: 'CTA with background image',
    icon: Megaphone,
    defaultProps: {
      heading: 'Ready to Get Started?',
      subheading: 'Take the next step with us today.',
      ctaText: 'Contact Us',
      ctaLink: '/about',
      backgroundImage: '',
    },
  },
  text_block: {
    label: 'Text Block',
    description: 'Heading and paragraph text',
    icon: Type,
    defaultProps: {
      heading: 'Section Heading',
      content: 'Add your content here. You can write multiple paragraphs separated by line breaks.',
      alignment: 'left',
    },
  },
  text_image: {
    label: 'Text + Image',
    description: 'Side-by-side text and image',
    icon: Image,
    defaultProps: {
      heading: 'Section Heading',
      content: 'Add your content here. Describe your section with compelling text.',
      image: '',
      layout: 'text-left',
    },
  },
  testimonials: {
    label: 'Testimonials',
    description: 'Customer reviews from CMS',
    icon: MessageSquare,
    defaultProps: {
      heading: 'Testimonials',
      subheading: 'What our clients say',
    },
  },
  featured_inventory: {
    label: 'Featured Inventory',
    description: 'Auto-populated from inventory',
    icon: GripHorizontal,
    defaultProps: {
      heading: 'Featured Inventory',
      subheading: 'Hand-picked units ready for the road',
      linkText: 'View All',
    },
  },
  contact_cards: {
    label: 'Contact Cards',
    description: 'Address, phone, email cards',
    icon: MapPin,
    defaultProps: {
      items: [
        { icon: 'MapPin', title: 'Address', text: 'Your address here' },
        { icon: 'Phone', title: 'Phone', text: '(000) 000-0000' },
        { icon: 'Mail', title: 'Email', text: 'email@example.com' },
        { icon: 'Clock', title: 'Hours', text: 'Mon-Fri 9AM-6PM' },
      ],
    },
  },
  spacer: {
    label: 'Spacer',
    description: 'Empty vertical space',
    icon: GripHorizontal,
    defaultProps: { height: 60 },
  },
};
